import {Component, EventEmitter, OnInit, Output, Renderer2} from '@angular/core';
import {CheckoutService} from '../checkout.service';
import {HttpStatusCode} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {ScriptService} from '../../script.service';

@Component({
    selector: 'app-add-card',
    templateUrl: './add-card.component.html',
    styleUrls: ['./add-card.component.scss']
})
export class AddCardComponent implements OnInit {
    unableToLoadFrame = false;
    checkoutIsReady = false;
    onTokenizedCard = false;
    // onUserError: any;

    libLoadingRetryCounter = 0;

    @Output() isAddedCardOk = new EventEmitter<boolean>();

    constructor(
        private checkoutService: CheckoutService,
        private scriptService: ScriptService,
        private renderer: Renderer2,
    ) {
    }

    ngOnInit() {
        this.loadCheckoutLib();
    }

    private loadCheckoutLib(): void {
        const checkIfLibIsLoaded = this.scriptService.findScript('conekta_lib');

        if (checkIfLibIsLoaded) {
            this.generateToken();
            return;
        }

        const conektaScript = this.scriptService.loadJsScript(
            this.renderer,
            'https://pay.conekta.com/v1.0/js/conekta-checkout.min.js',
            'conekta_lib'
        );

        conektaScript.onload = () => {
            console.log('Conekta Library loaded');
            this.generateToken();
        };

        conektaScript.onerror = () => {
            if (this.libLoadingRetryCounter >= 5) {
                this.unableToLoadFrame = true;
                return;
            }

            console.warn(`Unable to load lib this time, Applying retry policy attempt: ${this.libLoadingRetryCounter}`);
            this.loadCheckoutLib();
            this.libLoadingRetryCounter++;
        };
    }

    cancelCardAdding(): void {
        const err = new Error('The user has been canceled the process.');
        this.onGeneratedPaymentMethodError(err);
    }

    // validUserResponse(data: any): boolean {
    //     const email = data.email;
    //     const phone = data.telefono;
    //
    //     return !!(email && phone);
    // }

    private generateToken(): void {
        this.checkoutService.generateToken().subscribe(
            response => this.onTokenResultSuccess(response),
            error => this.onTokenResultError(error),
        );
    }

    onTokenResultSuccess(response: any): void {
        const {data} = response;
        const {id} = data;

        if (id) {
            this.loadCheckout(data);
        }
    }

    onTokenResultError(error: any): void {
        console.error(error);
    }

    loadCheckout(data: any): any {
        const ckPublicKey = environment.ckPublicKey;
        const {checkout} = data;
        const {id} = checkout;

        try {
            window['ConektaCheckoutComponents'].Card({
                targetIFrame: '#conektaIframeContainer',
                allowTokenization: true,
                checkoutRequestId: id, // checkout id from token request
                publicKey: ckPublicKey, // your public key
                locale: 'es', // 'es' Español | 'en' Ingles
                options: {
                    styles: {
                        inputType: 'default',
                        buttonType: 'default',
                        colors: {
                            primary: '#0c4d94' // for button color
                        },
                        background: {
                            header: 'transparent',
                            body: 'transparent'
                        },
                        states: {
                            empty: {
                                borderColor: '#FFAA00'
                            },
                            invalid: {
                                borderColor: '#FF00E0'
                            },
                            valid: {
                                borderColor: '#0079c1'
                            }
                        }
                    },
                    button: {
                        colorText: '#ffffff',
                        buttonPayText: 'Agregar tarjeta'
                    },
                    iframe: {
                        colorText: '#333333',
                        backgroundColor: 'transparent'
                    }
                },
                onCreateTokenSucceeded: (token) => this.onTokenizationSuccess(token),
                onCreateTokenError: (error) => this.onTokenizationError(error),
                onFinalizePayment: (event) => {
                    console.log('On Finalize payment');
                    console.log(event);
                },
                onErrorPayment: (event) => {
                    console.log('On Error payment');
                    console.log(event);
                }
            });
            this.checkoutIsReady = true;
        } catch (error) {
            this.unableToLoadFrame = true;
        }
    }

    onTokenizationSuccess(token: any): void {
        console.log('on tokenization success');
        this.getExistingCustomerToAddCard(token);
    }

    onTokenizationError(error: Error): void {
        console.error(error);
    }

    getExistingCustomerToAddCard(token: any): void {
        this.checkoutService.getCustomerById().subscribe(
            (response) => {
                this.onGetConektaCustomerResponse(response, token);
            },
            (error) => {
                this.onGetConektaCustomerError(error, token);
            },
        );
    }

    private onGetConektaCustomerResponse(response: any, token: any): void {
        console.log(response);

        if (response.statusCode === HttpStatusCode.Ok) {
            const {data: customer} = response;
            this.addCardToExistingCustomer(customer, token);
        }
    }

    private onGetConektaCustomerError(error: any, token: any): void {
        // if (error.includes('404')) {
        //     this.requestNewCustomer(token);
        //     return;
        // }

        console.log(error);

        const {status} = error;

        if (status === HttpStatusCode.NotFound) {
            this.requestNewCustomer(token);
            return;
        }

        console.error(error);
    }

    requestNewCustomer(token: any): void {
        const body = {token};

        this.checkoutService.requestNewCustomer(body).subscribe(
            response => this.onCreateCustomerResultSuccess(response),
            error => this.onCreateCustomerResultError(error)
        );
    }

    onCreateCustomerResultSuccess(response: any): void {
        this.onAddedCardResponse(response);
    }

    onCreateCustomerResultError(error: Error): void {
        this.isAddedCardOk.emit(false);
        console.error(error);
    }

    onGeneratedPaymentMethodError(error: Error): void {
        this.isAddedCardOk.emit(false);
        console.error(error);
    }

    addCardToExistingCustomer(customer: any, token: any): void {
        this.checkoutService.addCardToCustomer(customer, token).subscribe(
            response => this.onAddedCardResponse(response),
            error => this.onAddedCardError(error)
        );
    }

    onAddedCardResponse(response): void {
        this.isAddedCardOk.emit(true);
        console.log(response);
    }

    onAddedCardError(error): void {
        this.isAddedCardOk.emit(false);
        console.error(error);
    }
}
